module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("jjKyj"))).then(() => parcelRequire('gIkZ4'));